<div [class.payment-failed]="failedPayment">
  <cc-top-bar [title]="('ORDER_NUMBER.GET_NUMBER' | translate)"></cc-top-bar>

  <!-- Remove **ngIf if the possibility to add existing user number is needed again -->

  <cc-get-number-top-bar *ngIf="!isFullyConfigured"
    text="{{isFullyConfigured ? 'ORDER_NUMBER.USE_EXISTING_NO_NUMBERS' : 'ORDER_NUMBER.FREE_PORTING_TEXT'}}"
    boldText="{{isFullyConfigured ? 'ORDER_NUMBER.BUSINESS' : 'ORDER_NUMBER.FREE_PORTING'}}"
    (topBarClick)="onToBarClicked()">
  </cc-get-number-top-bar>

  <div class="responsive-container" [class.payment-failed]="failedPayment">
    <router-outlet></router-outlet>
  </div>
</div>
